"use strict";
const React = require("react");
const configs = /* @__PURE__ */ new Map();
function relativeUrl(from, to) {
  return new URL(to, from).href;
}
function Visualizer(props) {
  const currentHref2 = window.location.href;
  let { viewURL, dataURL, config, queryType = "fragment", url } = props;
  if (viewURL) {
    viewURL = relativeUrl(currentHref2, viewURL);
  }
  if (dataURL) {
    dataURL = relativeUrl(currentHref2, dataURL);
  }
  if (typeof config !== "string") {
    config = createBlobConfig(config);
  }
  const style = props.style || {
    width: "100%",
    height: "100%",
    position: "absolute",
    border: "none"
  };
  const search = new URLSearchParams();
  const query = {
    viewURL,
    dataURL,
    config,
    ...props.queryParameters
  };
  for (let [key, value] of Object.entries(query)) {
    if (value) {
      search.set(key, value);
    }
  }
  return /* @__PURE__ */ React.createElement(
    "iframe",
    {
      allowFullScreen: true,
      src: `${url}${queryType === "fragment" ? "#" : ""}?` + search.toString(),
      style
    }
  );
}
function createBlobConfig(config) {
  if (typeof config === "object" && config !== null) {
    let processedConfig = config;
    if (config.header?.elements) {
      processedConfig = structuredClone(config);
      const els = processedConfig.header.elements;
      for (let i = 0; i < els.length; i++) {
        if (els[i].url) els[i].url = relativeUrl(currentHref, els[i].url);
      }
    }
    const configJson = JSON.stringify(processedConfig);
    if (configs.has(configJson)) {
      return configs.get(configJson);
    }
    const blob = URL.createObjectURL(
      new Blob([configJson], { type: "application/json" })
    );
    configs.set(configJson, blob);
  }
  return null;
}
module.exports = React.memo(Visualizer);
